import { render } from "./SeasonsCopyComponent.vue?vue&type=template&id=23a4a4c4&scoped=true&ts=true"
import script from "./SeasonsCopyComponent.vue?vue&type=script&lang=ts"
export * from "./SeasonsCopyComponent.vue?vue&type=script&lang=ts"

import "./SeasonsCopyComponent.vue?vue&type=style&index=0&id=23a4a4c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a4a4c4"]])

export default __exports__